
export class PersonalizeOrderResponseModel {
  public invoicePrefix: string;
  public orderStatus: number;
  public beforeShippingCancelCharges: number;
  public afterShippingCancelCharges: number;

  constructor(Sitesettingresponse: any) {
    this.invoicePrefix = Sitesettingresponse.invoicePrefix || '';
    this.orderStatus = Sitesettingresponse.orderStatus || 0;
    this.beforeShippingCancelCharges = Sitesettingresponse.beforeShippingCancelCharges || 0;
    this.afterShippingCancelCharges = Sitesettingresponse.afterShippingCancelCharges || 0;
  }
}
